<template>
    <DsToast group="root-flash-toast" />
    <CompanyPortalSpaLayout
        v-if="$route.meta.layout === PortalLayout.SPA"
        v-bind="props"
    >
        <template #top>
            <slot name="top" />
        </template>
    </CompanyPortalSpaLayout>
    <CompanyPortalBlankLayout v-else-if="$route.meta.layout === PortalLayout.BLANK">
        <RouterView />
    </CompanyPortalBlankLayout>
    <CompanyPortalLaravelLayout
        v-else
        v-bind="props"
    >
        <template #top>
            <slot name="top" />
        </template>
        <template #content>
            <slot name="content" />
        </template>
        <template #footer>
            <slot name="footer" />
        </template>
    </CompanyPortalLaravelLayout>
</template>

<script setup lang="ts">
import DsToast from '@/components/design-system/toast/DsToast.vue';
import useDsToast from '@/components/design-system/toast/useDsToast';
import { INTEGRATION_ROUTES_INJECTION_KEY, NO_SIDEBAR_ROUTES_INJECTION_KEY } from '@/injection-keys';
import { PortalLayout } from '@/interfaces/layout/layout';
import type { CompanyPortalLaravelLayoutProps } from '@/layouts/company-portal-layout.types';
import CompanyPortalBlankLayout from '@/layouts/CompanyPortalBlankLayout.vue';
import CompanyPortalLaravelLayout from '@/layouts/CompanyPortalLaravelLayout.vue';
import CompanyPortalSpaLayout from '@/layouts/CompanyPortalSpaLayout.vue';
import { onMounted, provide } from 'vue';

provide(NO_SIDEBAR_ROUTES_INJECTION_KEY, ['login', 'user/mfa', 'password/reset', 'ssologin', 'client/home'] as const);
provide(INTEGRATION_ROUTES_INJECTION_KEY, ['user/softpro', '/user/vendor/'] as const);

const props = withDefaults(defineProps<CompanyPortalLaravelLayoutProps>(), {
    flashToasts: () => [],
});

const { addToast } = useDsToast('root-flash-toast');

onMounted(() => {
    props.flashToasts.forEach(addToast);
});
</script>
